<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
        <div class="add_tits" ref="title">
            <el-form class="form-inlines u-f u-ac u-jsb " :inline="true">
                <div>
                    <el-form-item label="模糊搜索">
                        <el-input v-model="titles" placeholder="请输入内容" clearable size="small"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="add">新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="option" label="选项" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip width="180"> </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>
        <!--  -->
        <el-dialog title="选项设置" :visible.sync="dialogs" top="80px" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="form" :model="form" label-width="140px" :rules="rule" class="demo-ruleForm">
                    <el-form-item label="选项" prop="options">
                        <el-input size="small" v-model="form.options"></el-input>
                    </el-form-item>
                    <el-form-item label="分值" prop="mark">
                        <el-slider v-model="form.mark" show-input></el-slider>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit('form')" size="small">确 定</el-button>
                <el-button @click="dialogs = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                dialog: false,
                titles: '',
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,

                // 
                eid: '',
                dialogs: false,
                form: {
                    options: '',
                    mark: 5,
                },
                rule: {
                    options: [{
                        required: true,
                        message: '选项不能为空'
                    }],
                    mark: [{
                        required: true,
                        message: '分值不能为空'
                    }]
                }
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 170 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 170 + 'px'
                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/questionOption/list", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        keyword: that.titles,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.totalCount
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },

            // 新增
            add() {
                let that = this
                that.dialogs = true
                that.eid = '0'
                that.clear()
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        let urls;
                        if (that.eid && that.eid != '0') {
                            urls = "/admin/questionOption/update"
                        } else {
                            urls = "/admin/questionOption/save"
                        }
                        axios
                            .post(`${urls}`, {
                                id: that.eid,
                                option: that.form.options,
                                score: that.form.mark,
                                author: that.user.id
                            }, {
                                token: true
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    that.dialogs = false
                                    that.search()
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                } else {
                                    that.$message.error(response.data.message);
                                }
                            })
                            .catch(error => {})
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            },
            handleEdit(index, row) {
                let that = this
                that.dialogs = true
                that.eid = row.id
                that.clear()
                axios
                    .post("/admin/questionOption/read", {
                        id: that.eid
                    }, {
                        token: true
                    })
                    .then(response => {
                        var data = response.data.data
                        if (data) {
                            that.form.options = data.option
                            that.form.mark = data.score
                        } else {
                            that.eid = ''
                        }
                    })
                    .catch(error => {})
            },
            handleDelete(index, row) {
                let that = this
                that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/questionOption/del", {
                            id: row.id
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                that.search()
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            } else {
                                that.$message.error(response.data.message);
                            }
                        })
                        .catch(error => {})

                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },

            clear() {
                let that = this
                that.form.options = ''
                that.form.mark = 5
            },

        },

    };
</script>


<style scoped>
    .ft_mr {
        margin: 10px;
    }
</style>